export const routes = (prefix) => [
    {
        path: `/${prefix}/departments`,
        name: `${prefix}.departments.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.departments.index`,
                PageDescription: "Department Chagres",
            }
        }
    },
];
